// Availability counter shown under the hero CTA.
// Update SLOTS_REMAINING and SLOTS_TOTAL at the start of each month
// to refresh the scarcity signal on the landing page.
export const SLOTS_REMAINING = 7;
export const SLOTS_TOTAL = 15;
export const SLOTS_PERIOD = "this month";
